export default {
  dealSize: 3,
  batchSize: 60,
  draftSize: 10,
  maxStat: 9,
  minStat: 0,
  minTextLength: 8,
  maxTextLength: 13,
  prefetchedImages: true
}
